import React from "react";
import {Suspense} from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import 'react-toastify/dist/ReactToastify.css';
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { I18nextProvider } from "react-i18next";
import i18n from "./traduction/i18n";
import { AuthProvider } from "./context/authContext";
import { ToastContainer } from 'react-toastify';
import { Loader } from "./pages/Layouts";

// import { ThemeProvider } from "@material-tailwind/react";
// import { MaterialTailwindControllerProvider } from "./context";

// console.log(window.location)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={<Loader />}>
    
    <Provider store={store}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        pauseOnHover
        newestOnTop
        theme="colored"
        style={{
          fontSize:13
        }}
      />
      <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter>
            <App />
        </BrowserRouter>
        </AuthProvider>
      </I18nextProvider>
    </Provider>
    </Suspense>
  </React.StrictMode>
);

// serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
